import Alert from 'react-s-alert';

export const showErrorMessage = ({ message, position = 'bottom-right' }) => {
  Alert.error(message, {
    position,
    effect: 'slide',
    beep: false,
    timeout: 5000,
    offset: 100,
  });
};

export const showSuccessMessage = ({ message, position = 'bottom-right' }) => {
  Alert.success(message, {
    position,
    effect: 'slide',
    beep: false,
    timeout: 5000,
    offset: 100,
  });
};

export function filterObjectKeys(obj, string) {
  const filteredEntries = Object.entries(obj || {}).filter(([key]) => key.startsWith(string));

  return Object.fromEntries(filteredEntries);
}

export function capitalizeEveryFirstLetter(str) {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

export const isBoolean = (variable) => typeof variable === 'boolean' || variable instanceof Boolean;

export const getQueryParam = (key) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

export const setQueryParams = (params, keys) => {
  if (!params) {
    return;
  }

  const url = new URL(window.location);
  const urlParams = new URLSearchParams();

  Object.keys(params)
    .filter((key) => !keys || keys.includes(key))
    .forEach((key) => {
      if (params[key] === null || params[key] === undefined || params[key] === '') {
        urlParams.delete(key);
      } else {
        urlParams.set(key, params[key]);
      }
    });

  // Update the URL without reloading the page
  const newUrl = urlParams.toString() ? `${url.pathname}?${urlParams.toString()}` : url.pathname;
  window.history.replaceState(null, '', newUrl);
};

export const updateQueryParam = (key, value) =>
  new Promise((resolve) => {
    const url = new URL(window.location);
    const urlParams = new URLSearchParams(url.search);

    if (value === null || value === undefined || value === '') {
      urlParams.delete(key);
    } else {
      urlParams.set(key, value);
    }

    // Update the URL without reloading the page
    const newUrl = urlParams.toString() ? `${url.pathname}?${urlParams.toString()}` : url.pathname;
    window.history.replaceState(null, '', newUrl);

    resolve();
  });

export const removeFalsyValues = (obj) =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {});

export const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));

/**
 * The backend's `{ message }` from an axios error, or `fallback` when the
 * failure carries none (a network error, an empty body). Relayed verbatim —
 * never pattern-matched — per the architecture's error-body rule. Shared by
 * ProPrograms and the office promo-code dialogs.
 */
export const parseErrorMessage = (
  error,
  fallback = 'Something went wrong. Please try again.',
) => error?.response?.data?.message || fallback;
